const QualityIcon = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_28_1774)">
        <path
          d="M39.5993 20.0001C39.5993 9.38285 30.9923 0.775879 20.3751 0.775879C9.75785 0.775879 1.15088 9.38285 1.15088 20.0001C1.15088 30.6173 9.75785 39.2243 20.3751 39.2243C30.9923 39.2243 39.5993 30.6173 39.5993 20.0001Z"
          stroke="url(#paint0_linear_28_1774)"
          strokeMiterlimit="10"
        />
        <path
          d="M31.7483 18.4562C31.7486 18.0132 31.6225 17.5793 31.3847 17.2055C31.147 16.8318 30.8075 16.5336 30.4062 16.346C29.81 16.0285 29.3537 15.5002 29.1261 14.8643L29.0796 14.7401C28.8155 14.1094 28.7852 13.4052 28.9942 12.7541C29.1214 12.3485 29.135 11.9157 29.0336 11.5029C28.9322 11.09 28.7197 10.7128 28.4191 10.4122C28.1185 10.1116 27.7413 9.89911 27.3285 9.79772C26.9156 9.69634 26.4829 9.70996 26.0772 9.83712C25.4262 10.0461 24.7219 10.0159 24.0912 9.75178L23.9671 9.69748C23.3301 9.47583 22.8007 9.02126 22.4853 8.42517C22.2983 8.02319 22.0003 7.68299 21.6265 7.44461C21.2527 7.20623 20.8185 7.07959 20.3751 7.07959C19.9318 7.07959 19.4976 7.20623 19.1238 7.44461C18.75 7.68299 18.452 8.02319 18.265 8.42517C17.9502 9.01882 17.4242 9.47281 16.791 9.69748L16.6591 9.75178C16.0284 10.0159 15.3241 10.0461 14.6731 9.83712C14.2674 9.70996 13.8347 9.69634 13.4218 9.79772C13.009 9.89911 12.6318 10.1116 12.3312 10.4122C12.0306 10.7128 11.8181 11.09 11.7167 11.5029C11.6153 11.9157 11.6289 12.3485 11.7561 12.7541C11.9675 13.4042 11.94 14.1085 11.6785 14.7401C11.6572 14.78 11.639 14.8215 11.6242 14.8643C11.3966 15.5002 10.9402 16.0285 10.3441 16.346C9.94213 16.5331 9.60193 16.831 9.36355 17.2049C9.12518 17.5787 8.99854 18.0128 8.99854 18.4562C8.99854 18.8996 9.12518 19.3337 9.36355 19.7075C9.60193 20.0814 9.94213 20.3793 10.3441 20.5664C10.9397 20.8808 11.3963 21.4066 11.6242 22.0404C11.6389 22.0856 11.6571 22.1297 11.6785 22.1723C11.923 22.7983 11.9395 23.4903 11.725 24.1273C11.5979 24.5329 11.5842 24.9656 11.6856 25.3785C11.787 25.7913 11.9996 26.1685 12.3002 26.4691C12.6008 26.7697 12.9779 26.9823 13.3908 27.0837C13.8036 27.185 14.2364 27.1714 14.642 27.0443C15.2916 26.8286 15.9973 26.8562 16.6281 27.1218L16.7599 27.1761C17.3941 27.4034 17.9201 27.8601 18.234 28.4562C18.421 28.8582 18.7189 29.1984 19.0928 29.4368C19.4666 29.6751 19.9008 29.8018 20.3441 29.8018C20.7875 29.8018 21.2216 29.6751 21.5955 29.4368C21.9693 29.1984 22.2672 28.8582 22.4543 28.4562C22.7694 27.8582 23.2986 27.401 23.936 27.1761L24.0602 27.1218C24.6909 26.8562 25.3967 26.8286 26.0462 27.0443C26.4519 27.1714 26.8846 27.185 27.2974 27.0837C27.7103 26.9823 28.0875 26.7697 28.3881 26.4691C28.6887 26.1685 28.9012 25.7913 29.0026 25.3785C29.104 24.9656 29.0904 24.5329 28.9632 24.1273C28.7542 23.4762 28.7845 22.7719 29.0485 22.1412L29.0951 22.0093C29.323 21.3755 29.7795 20.8498 30.3751 20.5353C30.7775 20.3545 31.1203 20.0631 31.3634 19.695C31.6065 19.3269 31.74 18.8973 31.7483 18.4562V18.4562Z"
          stroke="url(#paint1_linear_28_1774)"
          strokeMiterlimit="10"
        />
        <path
          d="M16.2944 18.4949L18.9942 21.1869L24.4558 15.7253"
          stroke="url(#paint2_linear_28_1774)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.9427 26.9355L10.7084 31.1093C10.6791 31.1654 10.6663 31.2287 10.6716 31.2917C10.6768 31.3548 10.6999 31.415 10.7382 31.4655C10.7764 31.5159 10.8282 31.5544 10.8875 31.5765C10.9468 31.5986 11.0111 31.6034 11.073 31.5903L14.2228 30.9386C14.291 30.9239 14.3621 30.931 14.4262 30.9588C14.4902 30.9866 14.5439 31.0339 14.5796 31.0938L15.5726 32.7385C15.6016 32.7902 15.6439 32.8332 15.695 32.8631C15.7461 32.8931 15.8043 32.9088 15.8636 32.9088C15.9228 32.9088 15.981 32.8931 16.0321 32.8631C16.0833 32.8332 16.1255 32.7902 16.1545 32.7385L18.2724 28.5259M27.5354 27.0519L29.7076 31.1171C29.737 31.1732 29.7497 31.2364 29.7445 31.2995C29.7392 31.3625 29.7161 31.4228 29.6779 31.4732C29.6397 31.5237 29.5879 31.5622 29.5286 31.5843C29.4693 31.6064 29.4049 31.6112 29.343 31.5981L26.1933 30.9464C26.125 30.9317 26.0539 30.9387 25.9899 30.9666C25.9259 30.9944 25.8722 31.0416 25.8364 31.1016L24.8434 32.7463C24.8144 32.7979 24.7722 32.8409 24.721 32.8709C24.6699 32.9008 24.6117 32.9166 24.5525 32.9166C24.4932 32.9166 24.435 32.9008 24.3839 32.8709C24.3328 32.8409 24.2905 32.7979 24.2616 32.7463L22.2988 28.8673"
          stroke="url(#paint3_linear_28_1774)"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_28_1774"
          x1="20.3751"
          y1="0.775879"
          x2="20.3751"
          y2="39.2243"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7767E4" />
          <stop offset="1" stopColor="#5C48E5" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_28_1774"
          x1="20.3734"
          y1="7.07959"
          x2="20.3734"
          y2="29.8018"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7767E4" />
          <stop offset="1" stopColor="#5C48E5" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_28_1774"
          x1="20.3751"
          y1="15.7253"
          x2="20.3751"
          y2="21.1869"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7767E4" />
          <stop offset="1" stopColor="#5C48E5" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_28_1774"
          x1="20.208"
          y1="26.9355"
          x2="20.208"
          y2="32.9166"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#7767E4" />
          <stop offset="1" stopColor="#5C48E5" />
        </linearGradient>
        <clipPath id="clip0_28_1774">
          <rect
            width="40"
            height="40"
            fill="white"
            transform="translate(0.375)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default QualityIcon;
